
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import {Action, Getter} from 'vuex-class';
  import {SkillModel} from '@/models/skill.model';
  import {Emit, Prop} from 'vue-property-decorator';
  import ListScaffold from '@/components/Shared/ListScaffold.vue';

  @Component({
    components: {ListScaffold}
  })
  export default class SkillsSelector extends Vue {
    @Action('requestAllSkills') fetchSkills: any;
    @Getter('skills') skillsList!: SkillModel[];
    @Prop({required: false, default: []}) selectedSkills!: number[];

    mounted() {
      this.fetchSkills()
    }

    skillAlreadySelected(skill: SkillModel): boolean {
      if (!skill.id) {
        return false;
      }

      return this.selectedSkills.includes(skill.id);
    }

    @Emit()
    onAddSkill(skill: SkillModel) {
      return skill
    }
  }
